import Vue from "vue";
import Vuex from "vuex";
import CategoryService from "@/services/CategoryService.js";
import forgiveness from "./forgiveness";
import { sortBy, isEmpty, concat, map } from "lodash";
import { getVal } from "@/utils";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    categories: [],
    answers: [],
    answerSelected: {},
    church_account_id: "",
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers;
    },
    SET_ANSWER_SELECTED(state, answerSelected) {
      state.answerSelected = answerSelected;
    },
    SET_ACCOUNT_ID(state, church_account_id) {
      state.church_account_id = church_account_id;
    },
  },
  modules: {},
  actions: {
    setAccountId({ commit }, church_account_id) {
      commit("SET_ACCOUNT_ID", church_account_id);
    },
    setAnswerSelected({ commit }, answerSelected) {
      commit("SET_ANSWER_SELECTED", answerSelected);
    },
    async fetchCategories(
      { commit },
      { catnames = [], showUnSelected = false }
    ) {
      try {
        const response = await CategoryService.getCategories();
        let dataSorted = sortBy(response.data, ["name"]);
        dataSorted.unshift(forgiveness);
        dataSorted = map(dataSorted, (item) => ({
          ...item,
          en: {
            name: item.name,
            description: item.description,
          },
          es: {
            name: getVal(item, "name_es", item.name),
            description: getVal(item, "description_es", item.description),
          },
        }));
        let filteredDataSorted = dataSorted;
        if (!isEmpty(catnames)) {
          filteredDataSorted = dataSorted.filter((cat) =>
            showUnSelected
              ? !catnames.includes(cat.slug)
              : catnames.includes(cat.slug)
          );
        }
        let answers = [];
        filteredDataSorted.forEach((item) => {
          // item.answers = filter(
          //   item.answers,
          //   (answer) => !isEmpty(answer.playerembed)
          // );
          item.answers = map(item.answers, (answer) => ({
            ...answer,
            en: {
              title: answer.title,
              description: answer.description,
              playerembed: answer.playerembed,
              transcript: answer.transcript,
            },
            es: {
              title: getVal(answer, "title_es", answer.title),
              description: getVal(answer, "description_es", answer.description),
              playerembed: getVal(answer, "playerembed_es", answer.playerembed),
              transcript: getVal(answer, "transcript_es", answer.transcript),
            },
          }));
          item.answers = sortBy(item.answers, (answer) =>
            isEmpty(answer.playerembed)
          );
          answers = concat(answers, item.answers);
        });
        commit("SET_CATEGORIES", filteredDataSorted);
        commit("SET_ANSWERS", answers);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
});
